import { render, staticRenderFns } from "./TaxSelector.vue?vue&type=template&id=c814062a&"
import script from "./TaxSelector.vue?vue&type=script&lang=js&"
export * from "./TaxSelector.vue?vue&type=script&lang=js&"
import style0 from "./TaxSelector.vue?vue&type=style&index=0&id=c814062a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports